import { api } from '../utils/apiHelpers';
import { UserDto } from './dtos/user';
import { dtoToUser } from './transformers/users';

export function fetchUserDetails() {
  return api.get<UserDto>('/v1/users/me').then(dtoToUser);
}

export function logout() {
  return api.post('/v1/users/logout');
}
